import { useEffect } from 'react';

// `enabled` lets a caller keep the hook call unconditional while skipping the
// injection itself (used to hold back trackers for stores with seo off)
const useScript = (url, selector = 'body', async = true, enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const element = document.querySelector(selector);
    const script = document.createElement('script');
    script.src = url;
    script.async = async;
    element.appendChild(script);
    return () => {
      element.removeChild(script);
    };
  }, [url, enabled]);
};

export default useScript;
